import { createFileRoute, Outlet } from '@tanstack/react-router';

import { makeMetaTitle } from '@/modules/META';
import { backendApiAdminLevelsFindOneOptions } from '@/modules/api/@tanstack/react-query.gen';

export const Route = createFileRoute('/verwaltung/$adminLevelId/benutzerinnen')({
  head: async ({
    params: { adminLevelId },
    match: {
      context: { queryClient },
    },
  }) => {
    const adminLevel = await queryClient.ensureQueryData(
      backendApiAdminLevelsFindOneOptions({ path: { adminLevelId } }),
    );

    return {
      meta: [makeMetaTitle([`Benutzer*innen ${adminLevel.name}`])],
    };
  },

  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
